/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function(){
  
  if(localStorage.getItem('lastSelected')){
     $('#effectiveAppsEGW').prop('checked', true);
     $('.Cart__GiftWrappingSelectBox').addClass('c-active');
     $('.slGiftSizeClass').val(localStorage.getItem('lastSelected'));
  }
  
    if(localStorage.getItem('lastSelected2')){
       $('#effectiveAppsEGW2').prop('checked', true);
       $('.Cart__GiftWrappingSelectBox2').addClass('c-active');
       $('.slGiftSizeClass2').val(localStorage.getItem('lastSelected2'));
    }
  
  $("input.SizeSwatch__RadioSize+label").addClass('disabled');
  var $valueColor = $('.SizeSwatch__RadioColor:checked').val();
  $(".ProductForm__Select option").each(function(){
      let $optionColor = $(this).data('option');
      if($valueColor == $optionColor){
          if($(this).data('quantity') > 0){
              var $optionSize = $(this).data('size');
              $('input.SizeSwatch__RadioSize').each(function(){
                  if($(this).val() == $optionSize){
                      $(this).next().removeClass('disabled');
                  }
              })
          }
      }
  });

  $('.SizeSwatch__RadioColor').click(function(){
      $("input.SizeSwatch__RadioSize+label").addClass('disabled');
      var $valueColor = $(this).val();
      $(".ProductForm__Select option").each(function(){
          let $optionColor = $(this).data('option');
          if($valueColor == $optionColor){
              if($(this).data('quantity') > 0){
                  var $optionSize = $(this).data('size');
                  $('input.SizeSwatch__RadioSize').each(function(){
                      if($(this).val() == $optionSize){
                          $(this).next().removeClass('disabled');
                      }
                  })
              }
          }
      });
  })
  
  
  $("input.SizeSwatch__RadioColor:checked+label").addClass('active');
  $("input.SizeSwatch__RadioColor+label").click(function(){
      $("input.SizeSwatch__RadioColor+label").removeClass('active');
      $(this).addClass('active');
  })
  
  $("input.SizeSwatch__RadioSize:checked+label").addClass('active');
  $("input.SizeSwatch__RadioSize+label").click(function(){
      $("input.SizeSwatch__RadioSize+label").removeClass('active');
      $(this).addClass('active');
  })

//   $('.ProductItem__ImageVariantList').each(function(){
//     $(this).slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       infinite: false,
//       swipe: true
//     })

//     $(this).on("mousedown touchstart", function () {
//       $(".c-featured-collections__slide").slick("slickSetOption", "swipe", false);
//     });
//     $(this).on("mouseup touchend", function () {
//       $(".c-featured-collections__slide").slick("slickSetOption", "swipe", true);
//     });

//     var $label = $(this).parents('.c-featured-collections__item').find('.ColorSwatch');

//     $label.click(function(){
//       $id = $(this).attr('for');
//       $input = $('#'+$id);
//       $dataImageID = $input.data('image-id');
//       console.log('dataImageID: '+$dataImageID);
//       $imageVariantItem = $(this).parents('.c-featured-collections__item').find('.ProductItem__ImageVariantItem');
//       $imageVariantItem.each(function(){
//         $dataImageID2 = $(this).data('image-id');
//         console.log('dataImageID2: '+$dataImageID2);
//         $imageVariantList = $(this).parents('.ProductItem__ImageVariantList');
//         if($dataImageID2 == $dataImageID){
//           $dataSlickIndex = $(this).data('slick-index');
//           $imageVariantList.slick('slickGoTo', $dataSlickIndex);
//         }
//       })
//     })
    

   if($('.template-cart').length){
      if($('.CartItem').length == 0){
         localStorage.removeItem('lastSelected');
        localStorage.removeItem('lastSelected2');
      }
      
      if($('.CartItem').length >= 1){
          var lstCartItem = $('.CartItem');
          var lstCartID = ['40466204459159', '40569647267991'];
          var lstCartID2 = ['44724185104535', '44705091846295', '44723672842391'];
          var lstId = [];
          for(let i = 0; i < lstCartItem.length; i++){
              var id = $(lstCartItem[i]).find('input[name="cartItemID"]').val();
              lstId.push(id);
          }
      
          if(!findCommonElements(lstId, lstCartID)){
              localStorage.removeItem('lastSelected');
          }else{
              let productID = lstId.filter(function(val) {
                  return lstCartID.indexOf(val) != -1;
              });
              localStorage.setItem('lastSelected', productID);
              $('#effectiveAppsEGW').prop('checked', true);
              $('.Cart__GiftWrappingSelectBox').addClass('c-active');
              $('.slGiftSizeClass').val(localStorage.getItem('lastSelected'));
          }

          // Shopper
          if(!findCommonElements(lstId, lstCartID2)){
              localStorage.removeItem('lastSelected2');
          }else{
              let productID = lstId.filter(function(val) {
                  return lstCartID2.indexOf(val) != -1;
              });

              
            
              localStorage.setItem('lastSelected2', productID);
              $('#effectiveAppsEGW2').prop('checked', true);
              $('.Cart__GiftWrappingSelectBox2').addClass('c-active');
              $('.slGiftSizeClass2').val(localStorage.getItem('lastSelected2'));
          }
      }
      
      $('.CartItem__Remove').click(function(){
          var id = $(this).parents('.CartItem').find('input[name="cartItemID"]').val();
          if(id == localStorage.getItem('lastSelected')){
              localStorage.removeItem('lastSelected');
          }
          if(id == localStorage.getItem('lastSelected2')){
              localStorage.removeItem('lastSelected2');
          }
      })
   }
   if (navigator.userAgent.indexOf('Mac OS X') != -1) {
       $("body").addClass("u-mac");
   }
  
   $('select[name="contact[question]"]').on('change', function() {
       $(this).addClass('selectChangeColor');
   });
   $('.slGiftSizeClass').on('change', function() {
       $(this).addClass('selectChangeColor');
   });
   $('select#delivery-time').on('change', function() {
       $(this).addClass('selectChangeColor');
   });


   if($('.template-collection').length){
       if($('.SectionHeader.SectionHeader__Vendor').length){
           setTimeout(() => {
               var $display = $('.SectionHeader.SectionHeader__Vendor .SectionHeader__Banner .u-img').css("display");
               if($display == 'none'){
                   $('#shopify-section-collection-template .SectionHeader__SubHeading').addClass('u-no-image');
                   $('.c-breadcrumbs').hide();
                   $('.c-breadcrumbs2').show();
               } else {
                   $('.c-breadcrumbs2').removeClass('c-breadcrumbs');
                   $('.c-breadcrumbs2').hide();
                   $('.c-breadcrumbs').show();
               }
           }, 100);
       }
   }


   // $('.Slideshow__Carousel').slick({
   //     arrows: true,
   //     infinite: false,
   //     dots: true,
   //     draggable: true,
   //       centerMode: true,
   //     slidesToShow: 1,
   //     slidesToScroll: 1,
   //     infinite: true,
   //     // fade: true,
   //     cssEase: 'linear',
   //     responsive: [
   //         {
   //             breakpoint: 768,
   //             settings: {
   //                 dots:false
   //             }
   //         }
   //     ]
   // });

   $('.About__WrapperImage').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       autoplay: true,
       autoplaySpeed: 2000,
       speed: 2000,
       dots:false,
       infinite: true,
       variableWidth: true,
       swipeToSlide: true,
       arrows: false,
       responsive: [
           {
               breakpoint: 800,
               settings: {
                   variableWidth: false
               }
           }
       ]
   });
 
   var flag = false;
   $('.ProductForm').submit(function(e){
       if (flag == false){
           e.preventDefault();
           if($('.ProductForm__Option select :selected').length){
               var policy = $('.ProductForm__Option select :selected').data('policy');
               var inventoryQuantity = $('.ProductForm__Option select :selected').data('quantity');
               var variantID = $('.ProductForm__Option select :selected').val();
           } else {
               var policy = $('.ProductForm__Special').data('policy');
               var inventoryQuantity = $('.ProductForm__Special').data('quantity');
           }

           if( variantID == '40575584075927' || variantID == '40466204459159' || variantID == '40569647267991' ){
               var policy = 'deny';
               console.log('box-gift');
           }
           var quantity = $('input[name="quantity"]').val();
           
           if( policy == 'deny' && inventoryQuantity >= parseInt(quantity)){
               flag = true;
               $('.ProductForm').submit();
           }else{
               alert('在庫がありません。');
           }
       }
   })
   
   

   if($('.template-cart').length){
       $('.Cart__GiftWrappingCheckBox .checkmark').click(function(){
           $('.Cart__GiftWrappingSelectBox').toggleClass('c-active');
       })

       $('.Cart__GiftWrappingCheckBox2 .checkmark').click(function(){
           $('.Cart__GiftWrappingSelectBox2').toggleClass('c-active');
       })

       $('.Cart__Checkout').click(function(){
          if($('.Cart__GiftWrappingSelectBox.c-active').length == 0){
             return true;
          }else if($('.Cart__GiftWrappingSelectBox.c-active').length == 1){
             var $select = $("#slGiftSizeID");
             if( $select.val() == 'サイズを指定' ){
                 $('.Cart__GiftWrappingSelectError').addClass('c-show');
                 return false;
             }
             else{
                 return true;
             }
          }
          
          if($('.Cart__GiftWrappingSelectBox2.c-active').length == 0){
             return true;
          }else if($('.Cart__GiftWrappingSelectBox2.c-active').length == 1){
             var $select = $("#slGiftSizeID2");
             if( $select.val() == 'サイズを指定' ){
                 $('.Cart__GiftWrappingSelectError2').addClass('c-show');
                 return false;
             }
             else{
                 return true;
             }
          }
       })

       $('#slGiftSizeID').change(() => {
           var productID = $('#slGiftSizeID').val();
           var lastSelectedId = localStorage.getItem('lastSelected');

           if(lastSelectedId && productID != lastSelectedId){
             // Remove cart
            $.ajax({
                url: `/cart/update.js`,
                type: "POST",
                // data: {
                //     updates: {
                //         [lastSelectedId]: 0
                //     }
                // },
                data: `updates[${lastSelectedId}]=0`,
                async: false,
                // contentType: 'application/json; charset=utf-8',
                success: function (response) {
                    addItemToCart(productID);
                },
                error: function (err) {
                    console.error(err);
                    return false;
                }
            });
           }
           else{
             addItemToCart(productID)
           }
       })

       // Shopper
        $('#slGiftSizeID2').change(() => {
           let productID = $('#slGiftSizeID2').val();
           let lastSelectedId = localStorage.getItem('lastSelected2');

           if(lastSelectedId && productID != lastSelectedId){
             // Remove cart
            $.ajax({
                url: `/cart/update.js`,
                type: "POST",
                data: `updates[${lastSelectedId}]=0`,
                async: false,
                // contentType: 'application/json; charset=utf-8',
                success: function (response) {
                    addItemToCart2(productID);
                },
                error: function (err) {
                    console.error(err);
                    return false;
                }
            });
           }
           else{
             addItemToCart2(productID)
           }
       })



   }
   
  

   // if($('.Cart__GiftWrappingSelectBox').length){
   //     var flag2 = false;
   //     $('form.Cart--expanded').submit(function(e){
   //         if (flag2 == false){
   //             e.preventDefault();
   //             var $select = $("#slGiftSizeID");
   //             if( $select.val() != 'サイズを指定' ){
   //                 flag2 = true;
   //                 $('form.Cart--expanded').submit();
   //             }else{
   //                 $('.Cart__GiftWrappingSelectError').addClass('c-show');
   //             }
   //         }
   //     })
   // }

   $('.egwSaveGiftOptionsBtn').click(function(){
       setTimeout(function(){
           location.href = location.href;
       }, 500);
   })

   $('form#create_customer').submit(function(){
       setTimeout(function(){
           var checkSignUpSuccess = setInterval(function() {
               var $item = $('.cf-form-inner .cf-verify-email-message');
               if ($item.length) {
                   clearInterval(checkSignUpSuccess);
                       var textDemo = `<div class="cf-verify-email-messageText">お客様の会員登録が完了しました。<br>
この度は UNION TOKYO にご登録いただきまして誠にありがとうございます。<br>
登録完了メールをお送りさせていただきました。<br>
ご登録いただいたメールアドレスおよびパスワード はログイン時に必要となりますので、大切に保管くださいますようお願いいたします。<br>
今後とも UNION TOKYO をどうぞよろしくお願いいたします。<div>`;
                   $('.SignUp .Form__Legend').html('');
                   $('.Form__Title').text('SIGN UP COMPLETE');
                   $item.html(textDemo);
               }
           }, 10); // check every 100ms
           
       },1000);
   })


   
   // $('.Slideshow__Carousel').slick({
   //     arrows: true,
   //     infinite: false,
   //     dots: true,
   //     draggable: true,
   //   	centerMode: true,
   //     slidesToShow: 1,
   //     slidesToScroll: 1,
   //     // fade: true,
   //     cssEase: 'linear',
   //     responsive: [
   //         {
   //             breakpoint: 1025,
   //             settings: {
   //                 slidesToShow: 1,
   //                 infinite: false,
   //                 centerMode: false,
   //             }
   //         },
   //         {
   //             breakpoint: 768,
   //             settings: {
   //                 slidesToShow: 1,
   //                 infinite: false,
   //                 centerMode: false,
   //                 dots:false
   //             }
   //         }
   //     ]
   // });
   
    setTimeout(function(){
        $('.Slideshow__Slide .Slideshow__Content').addClass('c-hidden');
        $('.Slideshow__Slide[data-slick-index="0"] .Slideshow__Content').removeClass('c-hidden');
        $('.Slideshow__Slide').each(function(){
            if($(this).data('slick-index') == 0 && $(this).hasClass('slick-current')){
                $(this).parents('.Slideshow__Carousel').find('.slick-prev').hide();
            }
        })
   }, 200);

   $('.Slideshow__Carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){ 
       $('.Slideshow__Slide .Slideshow__Content').addClass('c-hidden');
       if(currentSlide==0){
            $(this).find('.slick-prev').hide();
       } else {
        $(this).find('.slick-prev').show();
       }
       setTimeout(function(){
           $('.Slideshow__Slide[data-slick-index=' + currentSlide + '] .Slideshow__Content').removeClass('c-hidden');
       }, 200);
   });

//    setTimeout(function(){
//        $('.Slideshow__Slide[data-slick-index="0"] .Slideshow__Content').addClass('c-show-content');
//    }, 200);
//    $('.Slideshow__Carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){   
//        $('.Slideshow__Slide .Slideshow__Content').removeClass('c-show-content');
//        setTimeout(function(){
//            $('.Slideshow__Slide[data-slick-index=' + currentSlide + '] .Slideshow__Content').addClass('c-show-content');
//        }, 200);
//    });

   var linkWindow = window.location.pathname;
   $('.c-blog-template__tab-item').each(function(){
       var link = $(this).find('.c-blog-template__tab-link').attr('href');
       if(link == linkWindow){
           $(this).find('.c-blog-template__tab-link').addClass('c-current');
       }
   })

   $('#sl_blog > option').each(function(){
       var link = $(this).val();
       if(link == linkWindow){
           // $(this).attr('selected','selected');
           // $(this).setAttribute("selected", true);
           $(this).prop('selected', true);
       }
   })

   
   $('.ProductMeta__RestockHeading').on('click',function(){
       $(this).next().slideToggle("slow");
       $(this).toggleClass("c-show");
   });
   $('.ProductMeta__AccordionHeading').on('click',function(){
       $(this).next().slideToggle("slow");
       $(this).toggleClass("c-show");
   });
   $('.Cart__InformationLine').on('click',function(){
       $(this).find('.Cart__InformationHeading').next().slideToggle("slow");
       $(this).find('.Cart__InformationHeading').toggleClass("c-show");
   });

   // $('.Slideshow__Carousel').on('afterChange', function(event, slick, currentSlide){
   //     $('.shopify-section--slideshow .Slideshow__Slide.slick-center').prev().css('opacity', '0');
   // });

   // setTimeout(function(){
   //     $('.shopify-payment-button__button').text('BUY NOW');
   // },1000);

    if($('.template-product').length){
        var checkPaymentbutton = setInterval(function() {
            var $item = $('button[data-testid="Checkout-button"]');
            if ($item.length) {
                clearInterval(checkPaymentbutton);
                if($item.text() == '今すぐ購入'){
                    $item.hide();
                }
                console.log('hidden');
            }
        }, 100); // check every 100ms
    }

   if($('body').hasClass('template-index')){
       var checkInstagram = setInterval(function() {
           var $item = $('#insta-feed');
           var $item1 = $('#insta-feed .instafeed-lightbox');
           if ($item1.length) {
               clearInterval(checkInstagram);

               $item.addClass('Container c-instagram');
               setTimeout(function(){
                   $item.append('<div class="c-instagram__button"><a href="https://www.instagram.com/uniontokyo/" class="c-instagram__btn" target="_blank">FOLLOW US</a></div>');
               },3000);
           }
       }, 100); // check every 100ms
   }

   


   //Featured Collections 3
       function productSlider(){
           $('.c-featured-collections__slide').each(function(){
           var $sliderFeaturedCollections = $(this);
           var $progressBar = $(this).parents('.c-featured-collections__main').find('.c-featured-collections__progress');
           var $progressBarLabel = $(this).parents('.c-featured-collections__main').find( '.c-featured-collections__slider__label' );
           var $slideItem = $(this).parents('.c-featured-collections__main').find('.c-featured-collections__item');
           var $itemToShow = 4;

           // var slideCount = $slideItem.length;
           // function showProgress(){
           //     if(slideCount < 4){
           //         $progressBar.addClass('c-hidden');
           //     }else{
           //         $progressBar.removeClass('c-hidden');
           //     }
           // }

           // $(window).on("resize orientationchange", function () {
           //     showProgress();
           // });
           
           // var showProgress = function(slick, currentIndex){
           //     if(slick.count < 4){
           //         $progressBar.addClass('c-hidden');
           //     }else{
           //         $progressBar.removeClass('c-hidden');
           //     }
           // }
           // showProgress();

           // $(window).on("resize orientationchange", function () {
           //     showProgress();
           // });
           
           $(this).on('init',function(event,slick){
               $('.c-featured-collections__item').show();
               var calc = ( (1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;
               $progressBar
                 .css('background-size', calc + '% 100%')
                 .attr('aria-valuenow', calc );
               $progressBarLabel.text( calc + '% completed' );
               $('.ProductItem__Image').each(function(){
                   if($(this).attr('alt') == 'UNION GIFT BOX  M' || $(this).attr('alt') == 'UNION GIFT BOX L' || $(this).attr('alt') == 'UNION GIFT BOX S' || $(this).attr('alt') == 'Gift Wrap' || $(this).attr('alt') == 'UNION GIFT BOX L 1' ){
                       $(this).parents('.c-featured-collections__item').attr('style','display: none !important');
                   }
               })

               let slideCount = slick.slideCount;
               if($(window).width() >= 768){
                if(slideCount <= 4){
                    $(this).parents('.c-featured-collections__main').find('.c-featured-collections__bottom-box').hide();
                }
               } else if($(window).width() < 768){
                if(slideCount <= 2){
                    $(this).parents('.c-featured-collections__main').find('.c-featured-collections__bottom-box').hide();
                }
               }
           })
           $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
               var calc = ( (nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;
               
               $progressBar
               .css('background-size', calc + '% 100%')
               .attr('aria-valuenow', calc );
               
               $progressBarLabel.text( calc + '% completed' );
           });
           
           $(this).slick({
               slidesToShow: 4,
               slidesToScroll: 1,
               infinite: false,
               arrows: true,
               dots: false,
               draggable: true,
               appendArrows: $(this).parents('.c-featured-collections__main').find('.c-featured-collections__slide-arrow'),
               responsive: [
                   {
                       breakpoint: 768,
                       settings: {
                       arrows: true,
                       variableWidth: true,
                       slidesToShow: 2
                       }
                   }
               ]
           });
           });
       }
       productSlider();
   //End Featured Collections 3

   

   // ---------------------------------------------

   //Blog Posts Slideshow
       function blogPostsSlider(){
           $('.c-blog-posts__slideshow').each(function(){
           var self = $(this);
           var $slidesToShow = 1;
           var $variableWidth = false;
           var $dots = true;
           if(self.hasClass('c-blog-posts__slideshow--Launches')){
               // $slidesToShow = 2;
               $variableWidth = true;
               $dots = false;
               self.parents('.shopify-section--c-blog-posts').addClass('shopify-section--c-blog-posts--Launches');
           }
           var $sliderBlogPosts = $(this);

           var $progressBlogPosts = $(this).parents('.c-blog-posts__main').find('.c-blog-posts__progress');

           var $progressBarLabelBlogPosts = $(this).parents('.c-blog-posts__main').find( '.c-blog-posts__slider__label' );
           
           $sliderBlogPosts.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
               var calc = ( (nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;
               
               $progressBlogPosts
               .css('background-size', calc + '% 100%')
               .attr('aria-valuenow', calc );
               
               $progressBarLabelBlogPosts.text( calc + '% completed' );
           });

           $('.c-blog-posts__slideshow').on('init',function(event,slick){
               $('.c-blog-posts__article').show();
               let sildeCount = slick.slideCount;
               if(sildeCount <3){
                   $(this).parent().find('.c-blog-posts__bottom-box').hide();
               }

               var calc = ( (1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;
               $progressBlogPosts
                 .css('background-size', calc + '% 100%')
                 .attr('aria-valuenow', calc );
               $progressBarLabelBlogPosts.text( calc + '% completed' );
           })
           
           $sliderBlogPosts.slick({
               slidesToShow: 2,
               slidesToScroll: 1,
               infinite: false,
               arrows: true,
               dots: false,
               draggable: false,
               variableWidth: true,
               appendArrows: $(this).parents('.c-blog-posts__main').find('.c-blog-posts__slide-arrow'),
               responsive: [
               {
                   breakpoint: 769,
                   settings: {
                   arrows: false,
                   variableWidth: $variableWidth,
                   dots: $dots,
                   slidesToShow: $slidesToShow
                   }
               }
               ]
           });
           });
       }
       blogPostsSlider();
   //End Blog Posts Slideshow

   // ---------------------------------------------    


   // Featured Blog Post 

   var $slideNav = $('.c-blog-posts-grid__slideshow');
   function playNav() {
       var width = $(window).width();
       if (width <= 768) {
           $slideNav.not('.slick-initialized').slick({
               arrows: false,
               infinite: false,
               dots: true,
               draggable: true,
               slidesToShow: 1,
               slidesToScroll: 1
           });
       } else {
           if ($slideNav.hasClass("slick-initialized")) {
               $slideNav.slick("unslick");
           }
       }
   }
   
   var $slideNav2 = $('.c-collection-list__box');
   var $slideNavBar2 = $('.c-collection-list__progress');
   var $slideNavProgressBarLabel2 = $('.c-collection-list__slider__label');
   function playNav2() {
       var width2 = $(window).width();
       if (width2 <= 768) {

           $slideNav2.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
           var calc2 = ( (nextSlide) / (slick.slideCount-slick.options.slidesToShow) ) * 100;
           
           $slideNavBar2
               .css('background-size', calc2 + '% 100%')
               .attr('aria-valuenow', calc2 );
           
           $slideNavProgressBarLabel2.text( calc2 + '% completed' );
           });

           $slideNav2.not('.slick-initialized').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               infinite: false,
               arrows: false,
               dots: false,
               draggable: true,
               variableWidth: true
           });
       } else {
           if ($slideNav2.hasClass("slick-initialized")) {
               $slideNav2.slick("unslick");
           }
       }
   }

   $(window).on("resize orientationchange", function () {
       playNav();
       playNav2();
   });

   playNav();
   playNav2();

   
   // Featured Blog Post 








   $('.Footer__Accordion-title').on('click',function(){
     var self = $(this);
       $(this).next().slideToggle({
         duration:"slow",
         progress:function(){
           self.css({
             "pointer-events": "none",
           });
         },
         done:function(){
           self.css({
             "pointer-events": "auto",
           });
         }
     });
       $(this).toggleClass("c-show");
   });
   
   $('.Footer__Accordion-item .Collapsible__Plus').on('click',function(){
     $('.Footer__Accordion-list').slideToggle("slow");
       $('Footer__Accordion-list').toggleClass("c-show");
   });

   $('.PageOverlay').click(function(){
       $('.Search__Close').trigger('click');
   });

   function headerMobile(){
       if( $(window).width() < 1140 ){
           $('#shopify-section-header').addClass('js-header-mobile');
       }else{
           $('#shopify-section-header').removeClass('js-header-mobile');
       }
   }
   headerMobile();
   
   
   function heightSlideshow(){
       var $headerHeight = $('#section-header').outerHeight();
       var $announmenceHeight = $('#shopify-section-announcement').outerHeight();
       if($(window).width() < 1008){
           $('.shopify-section--slideshow .Slideshow__ImageContainer').outerHeight($(window).height() - $headerHeight - $announmenceHeight);
           $('.shopify-section--slideshow').outerHeight($(window).height() - $headerHeight - $announmenceHeight);
       }
   }
   heightSlideshow();

   function addressForm(){
       var $headerHeight2 = $('#section-header').outerHeight();
       var $announmenceHeight2 = $('#shopify-section-announcement').outerHeight();
       $('#modal-address-new').outerHeight($(window).height() - $headerHeight2 - $announmenceHeight2);
       $('#modal-address-new').offset({top: $headerHeight2 + $announmenceHeight2});
   }
   addressForm();

   $(window).resize(function(){
       headerMobile();
       heightSlideshow();
       addressForm();
   })

   if($('.c-vendor-collection').length){
       $('body').addClass('template-vendor-collection');
   }

   if($('.shopify-section--c-blog-posts--Launches').length){
    $('.c-launchesDate').each(function(){
        var dateRelease = Date.parse($(this).text());
        var dateNow = Date.now();
        if(dateRelease < dateNow){
            $(this).parents('.c-blog-template__article').find('.c-blog-template__article--image').addClass('is-expired');
            // $(this).parents('.shg-c-lg-4').find('.shogun-image-container').addClass('is-expired');
        }
        var d = new Date($(this).text());
        var weekday = [];
        weekday[0]="SUN";
        weekday[1]="MON";
        weekday[2]="TUE";
        weekday[3]="WED";
        weekday[4]="THU";
        weekday[5]="FRI";
        weekday[6]="SAT";
        var n = weekday[d.getDay()];
        var date = d.getDate();
        var month = d.getMonth() + 1;
        if(date<=9){
            date = '0'+date;
        }
        if(month<=9){
            month = '0'+month;
        }
        var result = month+'.'+date+'<span>'+n+'</span>';

        $(this).parents('.c-blog-posts__article').find('.c-date-release').html(result);
        // $(this).parents('.shg-c-lg-4').find('.c-date-release').html(result);
    })
   }

   if($('.c-launchesInfo').length){
       $('body').addClass('template-launches-collection');

       if($('.template-launches-collection').length){
           $('.c-launchesDate').each(function(){
               var dateRelease = Date.parse($(this).text());
               var dateNow = Date.now();
               if(dateRelease < dateNow){
                   $(this).parents('.c-blog-template__article').find('.c-blog-template__article--image').addClass('is-expired');
                   // $(this).parents('.shg-c-lg-4').find('.shogun-image-container').addClass('is-expired');
               }
               var d = new Date($(this).text());
               var weekday = [];
               weekday[0]="SUN";
               weekday[1]="MON";
               weekday[2]="TUE";
               weekday[3]="WED";
               weekday[4]="THU";
               weekday[5]="FRI";
               weekday[6]="SAT";

               var n = weekday[d.getDay()];
               var date = d.getDate();
               var month = d.getMonth() + 1;
               if(date<=9){
                   date = '0'+date;
               }
               if(month<=9){
                   month = '0'+month;
               }
               var result = month+'.'+date+'<span>'+n+'</span>';

               $(this).parents('.c-blog-template__article').find('.c-date-release').html(result);
               // $(this).parents('.shg-c-lg-4').find('.c-date-release').html(result);
           });
           var $dateCountDown = $('.c-blog-template__articleFirst-date').text().trim();
           countDown($dateCountDown);
       }
   }
   if($('.c-section-article-content').length){
       $('body').addClass('template-launches-article');
   }

   $('button[data-action="toggle-recover-form"]').click(function(){
       setTimeout(function(){
           $('.breadcrumb').html('<a href="/" title="Home">HOME</a><span class="c-breadcrumbs-arrow" aria-hidden="true"></span><a href="/account/login" title="Home">LOGIN</a><span class="c-breadcrumbs-arrow" aria-hidden="true"></span><span class="u-change">PASSWORD RESET</span>');
       }, 200)
   });

   if($('.u-recover').length){
       $('.breadcrumb').html('<a href="/" title="Home">HOME</a><span class="c-breadcrumbs-arrow" aria-hidden="true"></span><a href="/account/login" title="Home">LOGIN</a><span class="c-breadcrumbs-arrow" aria-hidden="true"></span><span class="u-change">PASSWORD RESET</span>');
   }
   

   var checkExistNewsletter = setInterval(function() {
       var $item = $('#footer-newsletter');
       if ($item.length) {
           clearInterval(checkExistNewsletter);
           $('#footer-newsletter').attr('action', '/contact');
       }
   }, 100); // check every 100ms

       
   if($('.template-index').length){
       $('.js-section--header').hover(function(){
           $(this).removeClass('js-mix-blend-mode-difference');
           $(this).addClass('js-mix-blend-mode-normal');
       },
       function(){
           var $windowTop2 = $(window).scrollTop();
           var headerHeight2 = 0;
           if($windowTop2 > headerHeight2){
               $(this).removeClass('js-mix-blend-mode-difference');
               $(this).addClass('js-mix-blend-mode-normal');
               
           }else{
             $(this).removeClass('js-mix-blend-mode-normal');
             setTimeout(function(){
               if($('.Search').attr('aria-hidden') == 'false'){

                 $(this).removeClass('js-mix-blend-mode-difference');
                 $(this).addClass('js-mix-blend-mode-normal');

               }else{
                 $(this).addClass('js-mix-blend-mode-difference');
               }
               if($(this).hasClass("js-mix-blend-mode-difference") && $(this).hasClass("js-mix-blend-mode-normal")){
                 $(this).removeClass("js-mix-blend-mode-difference");
               }
             }.bind(this),300);
           }
       });

       if($(window).scrollTop() > 0){
           $('#section-header').addClass('js-header-fix');
           $('#shopify-section-header').removeClass('js-mix-blend-mode-difference');
           $('#shopify-section-header').addClass('js-mix-blend-mode-normal');
       }
       
       $('.PageOverlay').click(()=>{
           var $windowTop3 = $(window).scrollTop();
           var headerHeight3 = 0;
           if($windowTop3 > headerHeight3){
               $('#shopify-section-header').addClass('js-mix-blend-mode-normal');
               $('#shopify-section-header').removeClass('js-mix-blend-mode-difference');
           }else{
               $('#shopify-section-header').removeClass('js-mix-blend-mode-normal');
               $('#shopify-section-header').addClass('js-mix-blend-mode-difference');
           }
       }) 
   }

   headerFix();
   $(window).scroll(function(){
       headerFix();
   });

   var temp = $(window).scrollTop();
   var headerHeight = 0;
   function headerFix(){
       var $windowTop = $(window).scrollTop();
       var $header = $('.js-header');

       if($(".DropdownMenu").attr('aria-hidden') == 'true' && $(".MegaMenu  ").attr('aria-hidden') == 'true'){
           if($windowTop > headerHeight){
               $header.addClass('js-header-fix');
               $('.js-section--header').removeClass('js-mix-blend-mode-difference');
           }else{
               $header.removeClass('js-header-fix');
               let hoverCheck2 = $('.js-section--header').filter(":hover").length;
               let scrollTop = $(window).scrollTop();
               if(hoverCheck2 == 0){
                   if($('#section-header').hasClass('Header--transparent')){
                       setTimeout(()=>{
                           $('.js-section--header').addClass('js-mix-blend-mode-difference');
                           setTimeout(function(){
                               if(!$('.js-section--header').hasClass('js-mix-blend-mode-difference')){
                                   $('.js-section--header').addClass('js-mix-blend-mode-difference');
                               }
                           },100);
                       },200);
                   }
               }
           }
       }
       temp = $windowTop;
   }
   
   var yearInput = $('.c-form-control__input__year select');
   var monthInput = $('.c-form-control__input__month select');
   var dayInput = $('.c-form-control__input__day select');
   var result = $('#create_customer-Birthday');
   var yearPlaceholder = '西暦';
   var monthPlaceholder = '月';
   var dayPlaceholder = '日';
   var ListofDays = [31,28,31,30,31,30,31,31,30,31,30,31];
   var year, month, day;
   function createDate(){
       var d = new Date();
       var c = d.getFullYear();
       initYear(c - 100, c);
       yearInput.on('change', function(){
       year = this.value;
       leapYears()
       showResult();
       })
       initMonth();
       monthInput.on('change', function(){
       month = this.value;
       leapYears()
       showResult();
       })
       initDay(31);
       dayInput.on('change', function(){
       day = this.value;
       showResult();
       })
   }
   function initYear(from, to) {
       var years = [];
       for(var i = to; i >= from; i--){
       years.push(i);
       }
       var options = optionHTML(years, yearPlaceholder);
       yearInput.html(options);
   }
   function initMonth() {
       var months = [];
       for(var i = 1; i <= 12; i++){
       months.push(i);
       }
       var options = optionHTML(months, monthPlaceholder);
       monthInput.html(options);
   }
   function initDay(a) {
       var days = [];
       for(var i = 1; i <= a; i++){
       days.push(i);
       }
       dayInput.empty();
       var options = optionHTML(days, dayPlaceholder);
       dayInput.html(options);
       if(day){
       if(dayInput.find('option[value='+day+']').length != 0) {
           dayInput.val(day);
       } else {
           dayInput.val("");
       }
       }
   }
   function optionHTML(arr, placeholder){
       var output = '<option value="" disabled selected>'+placeholder+'</option>';
       arr.forEach(function(i) {
       output += '<option value="'+i+'">'+i+'</option>';
       })
       return output;
   }
   function showResult(){
       if(year && month && day){
       result.val(year + '年' + month + '月' + day + '日');
       }
   }
   function leapYears() {
       if((year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) && month == 2) {
       initDay(29);
       } else {
       initDay(ListofDays[month-1]);
       }
   }
   createDate();

   $(".brand-filter-list li a").on("click", function (event) {
       event.preventDefault();
       try{
         var href = $(this).attr("href");
         var menuHeight = $(".Header__Wrapper").innerHeight();
         if($(href).length){
           $("html, body").animate({
             scrollTop: $(href).offset().top - menuHeight - 30
           }, 1000);
         }
         return false;
       }
       catch(err){
         console.log(err.message);
       }
   })

   // Pagination
   // $(function() {
   //     var $items = $(".c-column");
   //     var $numItems = $items.length;
   //     var $perPage = 7;

   //     // Only show the first 2 (or first `per_page`) items initially.
   //     $items.slice($perPage).hide();

   //     $('.c-launchesPaginate').pagination({
   //         items: $numItems,
   //         itemsOnPage: $perPage,
   //         cssStyle: 'light-theme',

   //         // This is the actual page changing functionality.
   //         onPageClick: function($pageNumber) {
   //         // We need to show and hide `tr`s appropriately.
   //         var $showFrom = $perPage * ($pageNumber - 1);
   //         var $showTo = $showFrom + $perPage;
   //         $('html, body').animate({scrollTop: 0}, 1000);

   //         // We'll first hide everything...
   //         $items.hide()
   //             // ... and then only show the appropriate rows.
   //             .slice($showFrom, $showTo).show();
   //     }
   //     });

   //     // EDIT: Let's cover URL fragments (i.e. #page-3 in the URL).
   //     // More thoroughly explained (including the regular expression) in: 
   //     // https://github.com/bilalakil/bin/tree/master/simplepagination/page-fragment/index.html

   //     // We'll create a function to check the URL fragment
   //     // and trigger a change of page accordingly.
   //     function checkFragment() {
   //     // If there's no hash, treat it like page 1.
   //     var hash = window.location.hash || "#page-1";

   //     // We'll use a regular expression to check the hash string.
   //     hash = hash.match(/^#page-(\d+)$/);

   //     if(hash) {
   //         // The `selectPage` function is described in the documentation.
   //         // We've captured the page number in a regex group: `(\d+)`.
   //         $(".c-launchesPaginate").pagination("selectPage", parseInt(hash[1]));
   //     }
   //     };

   //     // We'll call this function whenever back/forward is pressed...
   //     $(window).bind("popstate", checkFragment);

   //     // ... and we'll also call it when the page has loaded
   //     // (which is right now).
   //     checkFragment();
   // });
   // End Pagination

   //Account Menu SP
   $('.Account__Menu').click(function(){
       $('.Account__Sidebar').slideToggle('slow');
   })
   
   //Menu blog SP
   $('.c-div__abs').click(function(){
       $('.c-blog-template__tabBox').slideToggle('slow');
   })

   // if($('#swym-wishlist-render-container').length){
   //     // $('.swym-wishlist-list-card').click(function(){
   //     //     setPrice(600);
   //     // })

       
   //     var checkExistListCard = setInterval(function() {
   //         var $item = $('.swym-wishlist-list-card');
   //         if ($item.length) {
   //             console.log("Exists ListCard!");
   //             clearInterval(checkExistListCard);
   //             $('.swym-wishlist-list-card').click(function(){
   //                 setPrice(400);
   //             })
   //         }
   //     }, 100); // check every 100ms

       
   //     $('.swym-wishlist-list-card').click(function(){
   //         setPrice(400);
   //     })
       
   //     function setPrice(delay = 0) {
   //         var checkPriceExist = setInterval(function() {
   //         var $prices = $('.swym-product-final-price, .swym-product-original-price');
   //         var check = $()
   //         if ($prices.length) {
   //             console.log('Exist Price');
   //             clearInterval(checkPriceExist);
   //             setTimeout(function() {
   //             $('.swym-product-final-price, .swym-product-original-price').each(function(){
   //                 var val = $(this).text();
   //                 var price = parseInt(val.slice(1, val.length));
   //                 var formated = '¥' + numberWithCommas(parseInt(price));
   //                 $(this).html(formated);
   //             })

   //             if ($('.swym-wishlist-item').length) {
   //                 $(".swym-wishlist-item").unbind("click", itemClickHandle);
   //              $('.swym-wishlist-item').bind('click', itemClickHandle);
   //             }
   //             if ($('.swym-back-btn').length) {
   //                 $(".swym-back-btn").unbind("click", backClickHandle);
   //                 $('.swym-back-btn').bind('click', backClickHandle);
   //             }
   //             if ($('.swym-add-to-cart-btn').length) {
   //                 $(".swym-add-to-cart-btn").unbind("click", addToCartClickHandle);
   //             $('.swym-add-to-cart-btn').bind('click', addToCartClickHandle);
   //             }
   //             if ($('.swym-delete-btn').length) {
   //                 $(".swym-delete-btn").unbind("click", removeClickHandle);
   //             $('.swym-delete-btn').bind('click', removeClickHandle);
   //             }
   //             if ($('.swym-wishlist-add-to-cart-btn').length) {
   //                 $(".swym-wishlist-add-to-cart-btn").unbind("click", wishlistAddToCartClickHandle);
   //             $('.swym-wishlist-add-to-cart-btn').bind('click', wishlistAddToCartClickHandle);
   //             }
   //             if ($('.swym-product-tab').length) {
   //                 $(".swym-product-tab").unbind("click", productTabClickHandle);
   //                 $('.swym-product-tab').bind('click', productTabClickHandle);
   //             }
   //             // if ($('.swym-wishlist-list-card').length) {
   //             //     $('.swym-wishlist-list-card').unbind("click", openList);
   //             //     $('.swym-wishlist-list-card').bind('click', openList);
   //             // }
               

   //             }, delay)
   //         }
   //         }, 10)
   //     }
   //     // function openList(){
   //     //     setPrice(400);
   //     // }
   //     function itemClickHandle() {
   //         setPrice();
   //     }
   //     function backClickHandle() {
   //         setPrice(0);
   //     }
   //     function addToCartClickHandle() {
   //     $('.swym-product-final-price, .swym-product-original-price').text('');
   //     setPrice(600);
   //     }
   //     function removeClickHandle() {
   //     $('.swym-product-final-price, .swym-product-original-price').text('');
   //     setPrice(600);
   //     }
   //     function wishlistAddToCartClickHandle() {
   //     $('.swym-product-final-price, .swym-product-original-price').text('');
   //     setPrice(1500);
   //     }
   //     function productTabClickHandle() {
   //     setPrice(0);
   //     }
   // }
     
   // function numberWithCommas(x) {
   //     return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
   // }

   // Add Html to Checked Item
   
   var checkExistLimeSpot = setInterval(function() {
       var $item = $('limespot-box[data-owner="LimeSpot"] .ls-box-title');
       if ($item.length) {
           clearInterval(checkExistLimeSpot);
           $item.append("<a href='/collections/all' class='ls-box-link'> VIEW ALL ITEMS <img src='https://cdn.shopify.com/s/files/1/0555/6787/6247/files/arrow-black.png?v=1621841887'> </a>");
           $('.limespot-recommendation-box-grid-container').addClass('Container');
           $('.limespot-recommendation-box-grid-container').append("<div class='c-section-limespot__bottom-box'> <div class='c-section-limespot__progress' role='progressbar' aria-valuemin='0' aria-valuemax='100'><span class='c-section-limespot__label sr-only'></span></div><div class='c-section-limespot__slide-arrow'></div></div>");
           
           $('.limespot-recommendation-box-grid').on('init',function(event, slick){
               let slideCount = slick.slideCount;
               $(this).addClass('show-ls-slide');
               $('.ls-image').each(function(){
                   if($(this).attr('alt') == 'Gift Wrap' || $(this).attr('alt') == 'UNION GIFT BOX  M' || $(this).attr('alt') == 'UNION GIFT BOX S' || $(this).attr('alt') == 'UNION GIFT BOX L' || $(this).attr('alt') == 'UNION GIFT BOX L 1'  && slideCount == 1){
                       $(this).parent('.ls-recommendation-box ').attr('style','display: none !important');
                   } else if($(this).attr('alt') == 'Gift Wrap' || $(this).attr('alt') == 'UNION GIFT BOX  M' || $(this).attr('alt') == 'UNION GIFT BOX S' || $(this).attr('alt') == 'UNION GIFT BOX L' || $(this).attr('alt') == 'UNION GIFT BOX L 1' && slideCount > 1){
                       $(this).parents('.limespot-recommendation-box-item').attr('style','display:none!important');
                   } else {
                       $(this).parents('.limespot-recommendation-box-item').attr('style','display:block !important');
                   }
               })

               if($(window).width()>768){
                   if(slideCount <5){
                       $(this).parent().find('.c-section-limespot__bottom-box').hide();
                   }
               } else {
                   if(slideCount <3){
                       $(this).parent().find('.c-section-limespot__bottom-box').hide();
                   }   
               }
             
           
           })

           setTimeout(function(){
               function limespotSlider(){
                   $('.limespot-recommendation-box-grid').each(function(){
                       var $limespotSlider = $(this);
                       var $limespotProgressBar = $(this).parents('.c-section-limespot').find('.c-section-limespot__progress');
                       var $limespotProgressBarLabel = $(this).parents('.c-section-limespot').find('.c-section-limespot__label');

                       $limespotSlider.on('init', function(event, slick, currentSlide, nextSlide) {   
                           var calc2 = ( (1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;
                           $limespotProgressBar
                             .css('background-size', calc2 + '% 100%')
                             .attr('aria-valuenow', calc2 );
                           $limespotProgressBar.text( calc2 + '% completed' );
                           
                       });

                       $limespotSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
                           var calc2 = ( (nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;
                           
                           $limespotProgressBar
                               .css('background-size', calc2 + '% 100%')
                               .attr('aria-valuenow', calc2 );
                           
                           $limespotProgressBarLabel.text( calc2 + '% completed' );
                       });

                       $limespotSlider.slick({
                           slidesToShow: 4,
                           slidesToScroll: 1,
                           infinite: false,
                           arrows: true,
                           dots: false,
                           draggable: true,
                           variableWidth: true,
                           appendArrows: $(this).parents('.c-section-limespot').find('.c-section-limespot__slide-arrow'),
                           responsive: [
                               {
                                   breakpoint: 900,
                                   settings: {
                                       variableWidth: false,
                                       slidesToShow: 2
                                   }
                               }
                           ]
                       });
                   })
               }
               limespotSlider();
           }, 3000);

       }
   }, 100); // check every 100ms

   // if($('.template-cart').length){
   //     $('.CartItem__Title').each(function(){
   //         var title = $(this).find('a').html();
   //         if(title == 'Gift Wrap'){
   //             // $('.Cart__GiftWrapping').addClass('is-checked');
   //             // $(this).parents('.CartItem').hide();
   //             $('#effectiveAppsEGW').prop('checked', true);
   //         }
   //     })
   // }

   if($('.template-collection, .template-search-result').length){
       $('.CollectionToolbar__Item--filter').click(function(){
       // var drawer = $('#collection-filter-drawer').attr('aria-hidden');
           // if(drawer == 'false'){
           //     $('.PageOverlay').addClass('u-opacity-0');
           // }
           $('.PageOverlay').addClass('u-opacity-0');
       })
       $('.PageOverlay').click(function(){
           $('.PageOverlay').removeClass('u-opacity-0');
       })
   }

   // $('.Search__Input').attr("placeholder", "INPUT YOUR KEYWORDS");
   // setTimeout(function(){
   //     $('.Search__Input').attr("placeholder", "INPUT YOUR KEYWORDS");
   // }, 1000);

   var checkSeachInput = setInterval(function() {
       var $item = $('.boost-pfs-search-box');
       if ($item.length) {
           clearInterval(checkSeachInput);

           $('.boost-pfs-search-box').attr("placeholder", "INPUT YOUR KEYWORDS");
       }
   }, 100); // check every 100ms

   //Hide Gift Wrap Product
   
   if($('#shopify-section-collection-template').length > 0){
       setInterval(function(){
           $('.ProductItem__Image').each(function(){
               if($(this).attr('alt') == 'UNION GIFT BOX  M' || $(this).attr('alt') == 'UNION GIFT BOX S' || $(this).attr('alt') == 'UNION GIFT BOX L' || $(this).attr('alt') == 'Gift Wrap' || $(this).attr('alt') == 'UNION GIFT BOX L 1'){
                   $(this).parents('.Grid__Cell').hide();
               }
           })
       },100)
   }
   if($('.template-index').length){
       $('.HorizontalList__Item').hover(() => {
           let scrollTop = $(window).scrollTop();
           if(scrollTop === 0 && $('.HorizontalList__Item').hasClass('is-expanded')){
               $('#section-header').removeClass('Header--transparent');
           } 
       })

    //    $('#section-header').hover(()=>{
    //        let scrollTop = $(window).scrollTop();
    //        if(scrollTop === 0 && $('#shopify-section-header').hasClass('js-mix-blend-mode-normal js-mix-blend-mode-difference')){
    //            $('#shopify-section-header').removeClass('js-mix-blend-mode-normal');
    //        }  
    //    })
       
       var checkHeader;
       $(window).scroll(() => {
           let scrollTop = $(window).scrollTop();
           if(scrollTop === 0 && $('.HorizontalList__Item').hasClass('is-expanded')){
               setTimeout(function(){
                   $('#section-header').removeClass('Header--transparent');
               },1)
           }
			if(scrollTop === 0){
                let hoverCheck3 = $('.js-section--header').filter(":hover").length;
                setTimeout(function(){
                    if(!$('#shopify-section-header').hasClass('js-mix-blend-mode-difference')){
                        $('#shopify-section-header').addClass('js-mix-blend-mode-difference');
                        if(hoverCheck3 == 0){
                            $('#shopify-section-header').addClass('js-mix-blend-mode-difference');
                        }
                        else if(hoverCheck3 == 1){
                            $('#shopify-section-header').removeClass('js-mix-blend-mode-difference');
                        }
                    }
                },300)
           }
           
           

       });

       var scrollTop3 = $(window).scrollTop();
       if(scrollTop3 === 0){
            $('#shopify-section-header').addClass('js-mix-blend-mode-difference');
            $('#shopify-section-header').removeClass('js-mix-blend-mode-normal');
       }else{
            $('#shopify-section-header').removeClass('js-mix-blend-mode-difference');
            $('#shopify-section-header').addClass('js-mix-blend-mode-normal');
       }

       $("#shopify-section-header").hover(function(){
                  
        checkHeader = setInterval(() => {
            if($(window).scrollTop() === 0){
                if($('#shopify-section-header').hasClass('js-mix-blend-mode-difference')){
                    $('#shopify-section-header').removeClass('js-mix-blend-mode-difference');
                    $('#shopify-section-header').addClass('js-mix-blend-mode-normal');
                }
            }
        }, 1);
        
        }, function(){
            clearInterval(checkHeader);
            if ($(window).scrollTop() === 0){
                setTimeout(() => {
                    $('#shopify-section-header').addClass('js-mix-blend-mode-difference');
                    $('#shopify-section-header').removeClass('js-mix-blend-mode-normal');
                }, 300);
            }else{
                $('#shopify-section-header').removeClass('js-mix-blend-mode-difference');
                $('#shopify-section-header').addClass('js-mix-blend-mode-normal');
            }
        });

       
        
   }


   // setTimeout(function(){
   //     var interval_id = window.setInterval("", 9999); // Get a reference to the last
   //                                                 // interval +1
   //     for (var i = 1; i < interval_id; i++)
   //             window.clearInterval(i);
   //     //for clearing all intervals
   // }, 4000);
  
  

   var checkGiftBox = setInterval(function() {
       var $item = $('label[for="effectiveAppsEgwGiftWrap"] .checkbox-text #effectiveAppsEgwGiftWrapLbl');
       if ($item.length) {
           clearInterval(checkGiftBox);
           // var $text = $item.html();
           // var $text2 = $('label[for="effectiveAppsEgwGiftWrap"] .checkbox-text span.smallsize.shade-color').html();
           // console.log($text);
           // console.log($text2);
           // $('label[for="effectiveAppsEgwGiftWrap"] .checkbox-text').html('<span id="effectiveAppsEgwGiftWrapLbl">'+$text+'</span><br><span class="smallsize shade-color">' + $text2+'</span>');
           $('label[for="effectiveAppsEgwGiftWrap"] .checkbox-text').contents()
           .filter(function(){
           return this.nodeType != 1 && $.trim($(this).text()) != '';
           })
           .replaceWith("");
       }
   }, 100); // check every 100ms

   $(window).on("resize orientationchange", function () {
       let heightMenuSp = $('#section-header').outerHeight();
       let heightAnnouncementBar = $('#shopify-section-announcement').outerHeight();
       let total = heightMenuSp + heightAnnouncementBar;
       if($(window).width() <= 767){
           setTimeout(function(){
               $('#modal-address-new').css('max-height', 'calc( 100vh - ' + heightMenuSp+'px' + ' - ' + heightAnnouncementBar+'px' +')');
           },0)
       } else {
           $('#modal-address-new').css('max-height', 'calc( 100vh - ' + heightMenuSp+'px' + ' - ' + heightAnnouncementBar+'px' +')');
       }
   })
   
   if($('.template-article').length){
       if($('.c-article__date').length){
           var $dateCountDown = $('.c-article__date').text().trim();
           countDown($dateCountDown);

           var d = new Date($('.c-article__date').text().trim());
           var weekday = [];
           weekday[0]="SUN";
           weekday[1]="MON";
           weekday[2]="TUE";
           weekday[3]="WED";
           weekday[4]="THU";
           weekday[5]="FRI";
           weekday[6]="SAT";

           var n = weekday[d.getDay()];
           var date = d.getDate();
           var month = d.getMonth() + 1;
           if(date<=9){
               date = '0'+date;
           }
           if(month<=9){
               month = '0'+month;
           }
           var result = month+'.'+date+'<span>'+n+'</span>';

           $('.c-article__featuredImage .c-date-release').html(result);
       }

       $('.js-date').each(function(){
           var d = new Date($(this).text().trim());
           var weekday = [];
           weekday[0]="SUN";
           weekday[1]="MON";
           weekday[2]="TUE";
           weekday[3]="WED";
           weekday[4]="THU";
           weekday[5]="FRI";
           weekday[6]="SAT";

           var n = weekday[d.getDay()];
           var date = d.getDate();
           var month = d.getMonth() + 1;
           if(date<=9){
               date = '0'+date;
           }
           if(month<=9){
               month = '0'+month;
           }
           var result = month+'.'+date+'<span>'+n+'</span>';

           $(this).parents('.c-article__navItem').find('.c-date-release').html(result);
       })
   }

   $(window).on("load",function(){	
       if($("#shopify-section-header").hasClass("js-point-event-none")){	
           $("#shopify-section-header").removeClass("js-point-event-none");	
       }	
       $('.shopify-section--slideshow').addClass('c-show');
       $('.shopify-section--header').addClass('c-show');
       $('#shopify-section-announcement').addClass('c-show');
   });
	if($('.template-cart').length){	
    	$("#shopify-section-header").removeClass("js-point-event-none");	
   	}

   function countDown(date){
       const second = 1000,
             minute = second * 60,
             hour = minute * 60,
             day = hour * 24;
     
       let birthday = date,
       countDown = new Date(birthday).getTime(),
       nowToShowCheck = new Date().getTime()

       if(countDown > nowToShowCheck){
           x = setInterval(function() {    
       
               let now = new Date().getTime(),
               distance = countDown - now;
       
               $("#days").text(Math.floor(distance / (day)));
               $("#hours").text(Math.floor((distance % (day)) / (hour)));
               $("#mins").text(Math.floor((distance % (hour)) / (minute)));
               $("#secs").text(Math.floor((distance % (minute)) / second));
       
               //do something later when date is reached
               if (distance < 0) {
               // let headline = document.getElementById("headline"),
               //     countdown = document.getElementById("countdown"),
               //     content = document.getElementById("content");
       
               // headline.innerText = "It's my birthday!";
               // countdown.style.display = "none";
               // content.style.display = "block";

               $("#days").text('0');
               $("#hours").text('0');
               $("#mins").text('0');
               $("#secs").text('0');
       
               clearInterval(x);
               }
               //seconds
           }, 0)
       }
   }


   function addItemToCart(productID){
    $.ajax({
        url: "/cart/add.js",
        data: {
            items: [
                {
                quantity: 1,
                id: productID
                }
            ]
        },
        async: false,
        contentType: 'application/json; charset=utf-8',
        success: function (response) {
            localStorage.setItem('lastSelected', productID);
            location.reload();
            // $('form[name="formCheckout"]').submit();
        },
        error: function (err) {
            localStorage.removeItem('lastSelected');
            console.error(err);
            return false;
        }
    });
   }

   function addItemToCart2(productID){
    $.ajax({
        url: "/cart/add.js",
        data: {
            items: [
                {
                quantity: 1,
                id: productID
                }
            ]
        },
        async: false,
        contentType: 'application/json; charset=utf-8',
        success: function (response) {
            localStorage.setItem('lastSelected2', productID);
            location.reload();
        },
        error: function (err) {
            localStorage.removeItem('lastSelected2');
            console.error(err);
            return false;
        }
    });
   }
   

//    $('.shopify-section--slideshow').load(function(){
//         $('.shopify-section--slideshow').addClass('c-show');
//     })

    if(jQuery){
        $(this).addClass('c-show');
    }

    function findCommonElements(arr1, arr2) {
        return arr1.some(item => arr2.includes(item))
    }

    function parse_query_string(query) {
        var vars = query.split("&");
        var query_string = {};
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          var key = decodeURIComponent(pair[0]);
          var value = decodeURIComponent(pair[1]);
          // If first entry with this name
          if (typeof query_string[key] === "undefined") {
            query_string[key] = decodeURIComponent(value);
            // If second entry with this name
          } else if (typeof query_string[key] === "string") {
            var arr = [query_string[key], decodeURIComponent(value)];
            query_string[key] = arr;
            // If third or later entry with this name
          } else {
            query_string[key].push(decodeURIComponent(value));
          }
        }
        return query_string;
    }

    if($('.template-collection').length){
        if (FilterApi) {
            
            if (location.pathname != '/collections/vendors') {
                setTimeout(function() {
                    FilterApi.applyFilter();
                    console.log('Applied');
                },0)
            }

            if (location.pathname == '/collections/vendors') {
                if (window.location.href.indexOf("pf_v_vendor") > -1) {
                    var urlVendor = window.location.href.replace('pf_v_vendor', 'q');
                    window.history.pushState("", "", urlVendor);
                    // window.location.href = urlVendor;
                }
            }

            FilterApi.afterCall = function() {
                setTimeout(function() {
                if (location.pathname == '/collections/vendors') {

                    if (window.location.href.indexOf("pf_v_vendor") > -1) {
                        var urlVendor = window.location.href.replace('pf_v_vendor', 'q');
                        window.history.pushState("", "", urlVendor);
                    }
                    
                }
                
                $('.ProductItem').click(function() {
                    if (location.pathname == '/collections/vendors') {
                        // var query = window.location.search.substring(1);
                        // var qs = parse_query_string(query);
                        // var vendor = qs.q || qs.pf_v_vendor;
                        // var newurl = location.protocol + "//" + location.host + location.pathname + '?q=' + vendor;
                        // setTimeout(function() {
                        //     window.history.pushState({path:newurl},'',newurl);
                        // },0)
                        
                        setTimeout(function() {
                            if (window.location.href.indexOf("pf_v_vendor") > -1) {
                            var urlVendor = window.location.href.replace('pf_v_vendor', 'q');
                            window.history.pushState("", "", urlVendor);
                        }
                        },0)
                    }
                })
                }, 0)
            }
        }
    }

    $('.Form__Input[name="contact[question]"]').on('change',function(){
        if(this.value == 'ご注文に関するお問い合わせ'){
            $('input[name="contact[order_number]"]').attr('required',true);
        } else {
            $('input[name="contact[order_number]"]').attr('required',false);
        }
    });
    if ($('.template-account').length || $('.template-register').length) {
      CF.ready(function() {
        $('.SignUp form .cf-field[data-cf-field-type="radio"]').prepend('<label>性別</label>');
        $('.SignUp form .cf-field .cf-date-field--inline-inputs .cf-select-wrap select[placeholder="Year"] option:first-child').text('西暦');
        $('.SignUp form .cf-field .cf-date-field--inline-inputs .cf-select-wrap select[placeholder="Month"] option:first-child').text('月');
        $('.SignUp form .cf-field .cf-date-field--inline-inputs .cf-select-wrap select[placeholder="Day"] option:first-child').text('日');
        $( ".SignUp form .cf-field[data-cf-field-type=email] input" ).after( '<label class="FloatingLabel">Email</label>' );
        $( ".SignUp form .cf-field[data-cf-field-type=password] input" ).after( '<label class="FloatingLabel">Password</label>' );
      });
    }

});



